import { SET_MESSAGE_CONFIRMACAOEMAIL_ALTERACAO, SET_LOADING_VALUE_ALTERACAO_EMAIL } from './types';

const initialState = {
  screenInfo:{
    icon: '',
    title: '',
    discription: '',  
  },
  loading: false
}
export default function confirmacaoEmailAlteracaoReducer(state = initialState, action) {

  switch(action.type){
    case SET_MESSAGE_CONFIRMACAOEMAIL_ALTERACAO: return {...state, screenInfo: action.payload };
    case SET_LOADING_VALUE_ALTERACAO_EMAIL: return {...state, loading: action.payload};
    // case SET_ERROR_VALUE: return {...state, isError: action.payload};
    default: return state;
  }
}